import { Component, OnInit, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { UserService, JwtService, IdentityService } from '@app/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';
import { DeviceDetectorService } from '../../../node_modules/ngx-device-detector';


function dobValidation(c: AbstractControl): any {
  if (!c.parent || !c) return;
  const inputDOB = c.parent.get('dob');
  if (!inputDOB) return;
  var dtToday = new Date();
  var dDob = inputDOB.value;

  if (dDob != undefined && dDob != null && dDob != '') {
    var date = new Date(dDob.year, dDob.month - 1, dDob.day);
    if (date.toString() == "Invalid Date") {
      console.log("Invalid Date");
      return { invalid: true };
    }
    if (dDob.year < 1900) {
      console.log("year less than 1900");
      return { invalid: true };
    }
    else
      if (date > dtToday) {
        console.log("date is greater than today");
        return { invalid: true };
      }
  }
}

@Component({
  selector: 'app-identity',
  templateUrl: './identity.component.html',
  styleUrls: ['./identity.component.scss'],

})

export class IdentityComponent implements OnInit {

  is_BlockSuccess: boolean = false;
  is_VerifySuccess: boolean = false;
  is_RequestUserNameSuccess: boolean = false;
  is_RequestPasswordSuccess: boolean = false;
  loginMsg: string = '';
  closeResult: string;
  identityForm: FormGroup;
  showMask = true;
  link = 'register';
  enableRegister = false;
  enableForgotUsername = false;
  enableForgotPassword = false;
  socialSecurityNumber = '000000000';
  alertType = "";
  message = "";
  msgColor: string;
  alertTitle = "";
  asterik: string;
  closed = false;
  isError: boolean = false;
  today: any;
  hideForm: boolean = false;
  isDobError: boolean = false;
  constructor(private router: Router,
    private formBuilder: FormBuilder,
    private userService: UserService,
    private identityService: IdentityService,
    private jwtService: JwtService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private deviceService: DeviceDetectorService,
    private renderer: Renderer2
  ) {
    this.createForm();
  }

  ngOnInit() {
    var dt = new Date();
    this.today = {
      year: dt.getFullYear(), month: (dt.getMonth() + 1), day: dt.getDate()
    };
    //console.log("today");
    this.jwtService.destroyToken();
    this.userService.getTokenFromAuthServer().subscribe(
      data => {
        console.log('Token Saved');
      },
      err => {
        console.log('Unable to connect to API URL');
      }
    );
    this.route.queryParams.subscribe(params => {
      //console.log(params);
      this.link = params['link'];
    });
    this.checkLink(this.link);
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.jwtService.destroyToken();
  }


  getDate(formData): string {
    var dDob = formData.dob;
    if (dDob != null && dDob != undefined && dDob != '') {
      dDob = dDob.year + '-' + (dDob.month < 10 ? "0" + dDob.month : dDob.month) + '-' + (dDob.day < 10 ? '0' + dDob.day : dDob.day);
      console.log("yyyy-mm-dd" + dDob);
    }
    return dDob;
  }

  blockAccess = false;
  buttonText = "Next";
  enableBlock: boolean = false;
  pageheading = "Identity Verification";

  checkValue(event: any) {

    this.blockAccess = event.target.checked;
    if (this.blockAccess) {
      this.pageheading = "Block User";
      this.buttonText = "Block";
      this.enableBlock = true;
    } else {
      this.enableBlock = false;
      this.pageheading = "Identity Verification";
      this.buttonText = "Next";
      this.router.navigate(['/identity'], { replaceUrl: true });
    }
  }

  block() {
    var formData = this.identityForm.value;
    var dateOfBirth = this.getDate(formData);
    var ssn = this.getSSN(this.socialSecurityNumber);
    var data = { "ssn": ssn, "dob": dateOfBirth, "BlockCheck": this.blockAccess };
    console.log("block data" + data);

    this.identityService.blockWebAccess(data).subscribe(
      res => {
        if (res.code == '200') {
          this.is_BlockSuccess = true;
          this.hideForm = true;
          this.message = res.message;
          this.msgColor = 'green';
          this.asterik = '*';
        }
        else {
          this.identityForm.patchValue({
            ssn: null,
          });
        }
        setTimeout(function () {
          this.router.navigate(['/login'], { replaceUrl: true });
        }.bind(this), 5000);
      },
      err => {
        this.identityForm.patchValue({
          ssn: null,
          recaptchaReactive: null
        });
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
        grecaptcha.reset();
        this.isError = true;
      }
    );
    return false;
  }

  verify() {
    var formData = this.identityForm.value;
    var dateOfBirth = this.getDate(formData);
    var ssn = this.getSSN(this.socialSecurityNumber);
    var data = { "ssn": ssn, "dob": dateOfBirth, "BlockCheck": this.blockAccess };
    console.log("verify data" + data);
    this.identityService.isParticipant(data).subscribe(
      res => {
        this.is_VerifySuccess = true;
        if (res.data.identityVO)
          this.jwtService.saveIdentity(JSON.stringify(res.data.identityVO));
        this.router.navigate(['/register'], { replaceUrl: true });
      },
      err => {
        this.identityForm.patchValue({
          ssn: null,
          recaptchaReactive: null
        });
        this.asterik = '*';
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.isError = true;
        grecaptcha.reset();
      }
    );
    return false;
  }

  requestUsername() {
    var formData = this.identityForm.value;
    var dateOfBirth = this.getDate(formData);
    var ssn = this.getSSN(this.socialSecurityNumber);
    var data = { "ssn": ssn, "dob": dateOfBirth };
    this.identityService.sendUsername(data).subscribe(
      res => {
        if (res.code == '200') {
          this.is_RequestUserNameSuccess = true;
          this.message = res.message;
          this.hideForm = true;
          this.msgColor = 'green';
          this.asterik = '*';
          this.loginMsg = '<span>Please click <a  href="' + environment.ui_url + '/#/login">here</a> to login.</span>';
        }
        else {
          this.identityForm.patchValue({
            ssn: null,
            recaptchaReactive: null
          });
        }
      },
      err => {
        this.identityForm.patchValue({
          ssn: null,
        });
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
        grecaptcha.reset();
        this.isError = true;
      }
    );
    return false;
  }

  requestResetPassword() {
    var formData = this.identityForm.value;
    var dateOfBirth = this.getDate(formData);
    var ssn = this.getSSN(this.socialSecurityNumber);
    var data = { "ssn": ssn, "dob": dateOfBirth };
    this.identityService.sendPasswordLink(data).subscribe(
      res => {
        if (res.code == '200') {
          this.is_RequestPasswordSuccess = true;
          this.hideForm = true;
          this.message = res.message;
          this.msgColor = 'green';
          this.asterik = '*';
        }
        else {
          this.identityForm.patchValue({
            ssn: null,
            recaptchaReactive: null
          });
        }
      },
      err => {
        this.identityForm.patchValue({
          ssn: null,
        });
        this.message = err.errors.message;
        this.msgColor = 'red';
        this.asterik = '*';
        grecaptcha.reset();
        this.isError = true;
      }
    );
    return false;
  }

  cancel() {
    this.router.navigate(['/login'], { replaceUrl: true });
  }

  getStatusColor() {
    return this.msgColor;
  }
  checkLink(invokedFrom: string) {
    if (invokedFrom === 'forgotUsername') {
      this.enableForgotUsername = true;
      this.pageheading = "Forgot Username";
    } else if (invokedFrom === 'forgotPassword') {
      this.enableForgotPassword = true;
      this.pageheading = "Forgot Password";
    } else {
      this.enableRegister = true;
    }
  }
  getSSN(value) {
    return value.replace(/[-]/g, '')
  }
  isSSNError: boolean = false;
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  maskSSN(value) {
    var maskedValue = value;
    this.socialSecurityNumber = value;
    if (value != undefined && value.length == 11) {
      maskedValue = value.substr(0, value.length - 4).replace(/[\w]/g, 'x') + value.substr(-4);
      this.identityForm.patchValue({ ssn: maskedValue });
      this.isError = false;
    } else {
      return false;
    }
    return true;
  }
  removeErrorStyle(errorObj) {
    this.isError = false;
  }
  private createForm() {
    this.identityForm = this.formBuilder.group({
      ssn: ['', Validators.required],
      dob: ['', [Validators.required, dobValidation]],
      recaptchaReactive: ['', Validators.required]
    });
  }
}
